import {Button} from '@nlabs/gothamjs';

import {navigate} from '../lib/navigation';
import {buttonOutlineDark} from '../lib/styles';

export const PortalPreviewCard = () => (
  <div className="grid gap-4 rounded-[var(--nx-radius)] border border-[var(--nx-line)] bg-white p-[clamp(22px,4vw,36px)]">
    <p className="m-0 text-[.78rem] font-extrabold uppercase text-[var(--nx-blue)]">Phase 2 portal</p>
    <h3 className="m-0 text-[clamp(1.55rem,2.6vw,2.4rem)] leading-[1.08] text-[var(--nx-ink)]">Creator accounts are planned for manuscript tracking.</h3>
    <p className="m-0 leading-[1.7] text-[var(--nx-muted)]">
      The portal page is reserved for account sign-in, secure file upload, submission status, production notes, proof approvals, and format-specific deliverables.
    </p>
    <Button className={`${buttonOutlineDark} justify-self-start`} onClick={() => navigate('/portal')}>View Portal Preview</Button>
  </div>
);
